import { Directive, ElementRef, inject, Output } from '@angular/core';
import { filter, fromEvent } from 'rxjs';

@Directive({
  selector: '[lxNativeAutofill]',
  standalone: true,
})
export class FormDataAutofillDetectorDirective {
  private elRef: HTMLInputElement = inject(ElementRef<HTMLInputElement>).nativeElement;

  @Output() lxNativeAutofill = fromEvent(this.elRef, 'change').pipe(filter(() => [':autofill', ':-webkit-autofill'].some((s) => this.elRef.matches(s))));
}
